import { AppState } from '../reducers';
import { createSelector } from 'reselect';

export const selectClient = (state: AppState) => state.client;

export interface SelectedPointRelais {
  adresselivraison: string;
  cplivraison: string;
  villelivraison: string;
  relaisid: string;
  nompointrelais: string;
  fullName: string;
}

export const getSelectedPointRelais = createSelector(selectClient, client => ({
  adresselivraison: client.values.adresselivraison,
  cplivraison: client.values.cplivraison,
  villelivraison: client.values.villelivraison,
  relaisid: client.values.relaisid,
  nompointrelais: client.ui?.nompointrelais,
  fullName:
    client.ui?.nompointrelais +
    ' ' +
    client.values.adresselivraison +
    ' ' +
    client.values.cplivraison +
    ' ' +
    client.values.villelivraison
}));

export const getFullNameSelectedPointRelais = createSelector(
  selectClient,
  client =>
    client.ui?.nompointrelais +
    ' ' +
    client.values?.adresselivraison +
    ' ' +
    client.values?.cplivraison +
    ' ' +
    client.values?.villelivraison
);
